var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.pool
    ? _c("div", { staticClass: "page" }, [
        _c("div", { staticClass: "page-main" }, [
          _c("div", { staticClass: "page-header" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-md-12 col-lg-12 col-xl-12 col-xxl-10 offset-xxl-1",
              },
              [
                _c("h1", { staticClass: "page-title" }, [_vm._v("Prize")]),
                _c("breadcrumb", {
                  attrs: {
                    name: "PRIZE_SUMMARY_POOL_EDIT",
                    withLast: _vm.pool.name,
                  },
                  on: {
                    "update:withLast": function ($event) {
                      return _vm.$set(_vm.pool, "name", $event)
                    },
                    "update:with-last": function ($event) {
                      return _vm.$set(_vm.pool, "name", $event)
                    },
                  },
                }),
                _c("div", { staticClass: "page-title page-header-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-round btn-default mx-10",
                      attrs: { type: "button" },
                      on: { click: _vm.goBack },
                    },
                    [
                      _c("i", {
                        staticClass: "icon md-chevron-left",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" Back "),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "page-content container-fluid" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-md-12 col-lg-12 col-xl-12 col-xxl-10 offset-xxl-1",
                },
                [
                  _c("div", { staticClass: "panel panel-bordered" }, [
                    _c("div", { staticClass: "panel-heading" }, [
                      _c("h3", { staticClass: "panel-title" }, [
                        _vm._v(
                          " Prize Pool Information - " +
                            _vm._s(_vm.pool.id) +
                            " "
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "panel-actions panel-actions-keep" },
                        [
                          _c("h4", [
                            _vm._v(
                              "Type: " +
                                _vm._s(_vm._f("capitalize")(_vm.pool.type))
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "panel-body" }, [
                      _vm.pool
                        ? _c(
                            "form",
                            { staticClass: "form-horizontal" },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group col-md-6" },
                                  [
                                    _c("PoolName", {
                                      attrs: { pool: _vm.pool },
                                      on: { updated: _vm.fetchPool },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "form-group col-md-3" },
                                  [
                                    _c("StatusDropdown", {
                                      attrs: { pool: _vm.pool },
                                      on: { updated: _vm.fetchPool },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("hr"),
                              _c("VendorSelector", {
                                attrs: { pool: _vm.pool },
                                on: { updated: _vm.fetchPool },
                              }),
                              _c("hr"),
                              _c("div", { staticClass: "col-md-12" }, [
                                _c("h4", [_vm._v("Prize Details")]),
                                _c(
                                  "div",
                                  { staticClass: "px-10" },
                                  [
                                    _c("PrizeDetail", {
                                      attrs: { pool: _vm.pool },
                                      on: { updated: _vm.fetchPool },
                                    }),
                                    _c("PrizeDescription", {
                                      attrs: { pool: _vm.pool },
                                      on: { updated: _vm.fetchPool },
                                    }),
                                    _c("PrizePicture", {
                                      attrs: { pool: _vm.pool },
                                      on: { updated: _vm.fetchPool },
                                    }),
                                    _c("RequireAddress", {
                                      attrs: { pool: _vm.pool },
                                      on: { updated: _vm.fetchPool },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _c("hr"),
                              _c("AvailableCondition", {
                                attrs: { pool: _vm.pool },
                                on: { updated: _vm.fetchPool },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                    _vm._m(0),
                  ]),
                ]
              ),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-footer" }, [
      _c("div", { staticClass: "d-flex justify-content-between" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }